import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';
import NavigationLink from '@cotyorg/ccx-molecules/NavigationLink';
import NavigationTopLevel from '../NavigationTopLevel';
import NavigationContainer from '../../containers/NavigationContainer';

const NestedListComponent = ({ page, selectedSlug, isMobile }) => {
  const navigationLinkClassName = classNames(
    'navigation__link',
    'navigation__link--nested',
    'navigation__link--with-image',
    'navigation-featured-products__link--with-image',
    'cell',
    'xsmall-4',
  );

  const featuredItems = R.length(page.morePages) > 0 ? R.take(2, page.featured) : R.propOr([], 'featured', page);

  return (
    <div className="navigation__list-container">
      <div className="grid-container">
        <div className="navigation-featured-products__container-inner grid-x grid-margin-x">
          {(
            isObject(page) && Array.isArray(page.pages) &&
            <ul className="navigation__list navigation-featured-products__list cell xsmall-4">
              {
                page.pages.map(({
                  slug,
                  name,
                  pages,
                  url,
                  openInNewWindow,
                }) => (
                  <li key={slug} className="cell auto">
                    <NavigationLink
                      extraClass="navigation__link navigation__link--nested navigation-featured-products__link"
                      textExtraClass="navigation__link-text navigation__link-text--nested"
                      name={name}
                      pages={pages}
                      url={url}
                      openInNewWindow={openInNewWindow}
                      selected={slug === selectedSlug}
                    />
                  </li>
                ))
              }
            </ul>
          )}
          {(
            isObject(page) && Array.isArray(page.morePages) && R.length(page.morePages) > 0 &&
            <ul className="navigation__list navigation-featured-products__list cell xsmall-4">
              {
                page.morePages.map(({
                  slug,
                  name,
                  pages,
                  url,
                  openInNewWindow,
                }) => (
                  <li key={slug} className="cell auto">
                    <NavigationLink
                      extraClass="navigation__link navigation__link--nested navigation-featured-products__link"
                      textExtraClass="navigation__link-text navigation__link-text--nested"
                      name={name}
                      pages={pages}
                      url={url}
                      openInNewWindow={openInNewWindow}
                      selected={slug === selectedSlug}
                    />
                  </li>
                ))
              }
            </ul>
          )}
          {
            !isMobile && featuredItems.map(({
              slug,
              name,
              url,
              openInNewWindow,
              imageSrc,
              alt = '',
              imageSrcSet,
              label,
            }) => (
              <NavigationLink
                key={slug}
                extraClass={navigationLinkClassName}
                textExtraClass="navigation__link-text navigation__link-text--nested"
                name={name}
                url={url}
                openInNewWindow={openInNewWindow}
                imageSrc={imageSrc}
                alt={alt}
                imageSrcSet={imageSrcSet}
                label={label}
              />
            ))
          }
        </div>
      </div>
    </div>
  );
};

NestedListComponent.propTypes = {
  page: PropTypes.shape({
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      openInNewWindow: PropTypes.bool,
      pages: PropTypes.array,
    })),
    morePages: PropTypes.array,
    featured: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      imageSrc: PropTypes.string.isRequired,
      alt: PropTypes.string,
      label: PropTypes.string,
      openInNewWindow: PropTypes.bool,
    })),
  }),
  selectedSlug: PropTypes.string,
  isMobile: PropTypes.bool,
};

const NavigationFeaturedProducts = () => (
  <NavigationContainer
    extraClass="navigation-streamlined"
    NestedListComponent={NestedListComponent}
    childComponent={NavigationTopLevel}
  />
);

export default NavigationFeaturedProducts;
